import { useEffect, useState } from "react";

function App() {
  const [usuario, setUsuario] = useState("");
  const enlaces = [
    {
      id: "afiliados",
      url: "https://www.DescubreLiveGood.com/{usuario}",
      descripcion: `👉 Enlace de Afiliados
Este es tu enlace para compartir esta gran oportunidad con tus amigos, conocidos y futuros socios de LiveGood como miembros y afiliados.`,
      mensaje: `Hola 👋, aquí te comparto el enlace con el que podrás acceder a una oportunidad de negocios global, en la que formarás parte de un club de membresías con más de 2 millones de usuarios que pueden ahorrar y generar un ingreso extra mes a mes, sin presiones de comprar o vender productos, es una oportunidad maravillosa, da clic y nos vemos dentro.`
    },
    {
      id: "tienda1",
      url: "https://www.livegood.com/shop/{usuario}",
      descripcion: `👉 Este es tu enlace para compartir tu tienda online para que los clientes puedan ver ambos precios, tanto de cliente como de miembro y así pueda optar por convertirse en un miembro de LiveGood.`,
      mensaje: `Hola 👋, aquí te comparto un enlace con el que podrás acceder a nuestra tienda online y ver nuestros productos de gran calidad a precios imbatibles, recuerda que ver en gratis 😊 y créeme te vas a sorprender 😉.`
    },
    {
      id: "tienda2",
      url: "https://www.ShopLiveGood.com/{usuario}",
      descripcion: `👉 Tu Tienda Online #2
Este es nuestro sitio exclusivo para minoristas. Este sitio se parece al de LiveGood, pero solo muestra precios minoristas. No muestra precios para miembros. Úselo si solo le presenta nuestros productos a sus clientes y desea que paguen precios minoristas para que usted gane comisiones.`,
      mensaje: `Hola 👋, aquí te comparto un enlace con el que podrás acceder a nuestra tienda online y ver nuestros productos de gran calidad a precios imbatibles, recuerda que ver en gratis 😊 y créeme te vas a sorprender 😉.`
    },
    {
      id: "detox",
      url: "https://www.MyFreeDetox.com/{usuario}",
      descripcion: `👉 Con este enlace podrás ofrecer a tu clientes una botella de nuestro Detox completamente gratis con su primer pedido, también activará un Bot en Messenger una vez el cliente deje sus datos para hacer un seguimiento y convertirlo en un cliente recurrente.`,
      mensaje: `Hola 👋, te quiero hacerte un regalo. Con este enlace podrás obtener nuestro Detox completamente gratis con tu primera compra en nuestra tienda online, dale un vistazo que ver es gratis 😁 y conocerás de nuestros productos de gran calidad a precios imbatibles 💪`
    },
    {
      id: "salud",
      url: "https://www.MyFreeHealthReport.com/{usuario}",
      descripcion: `👉 Nota: De momento está en Inglés, pero se puede doblar con el traductor de Google del navegador.

Recomiende a las personas a este sitio para que respondan nuestro completo cuestionario de salud y obtengan una evaluación de salud GRATUITA de nuestro Director de Desarrollo de Productos, el Dr. Ryan Goodkin. Una vez completado el cuestionario, recibirán un informe gratuito y recomendaciones para mejorar su salud y alcanzar sus objetivos, ¡incluyendo recomendaciones de suplementos LiveGood! Cualquier persona que complete el cuestionario en su enlace será rastreada hasta usted, y cuando compren productos o se hagan miembros o afiliados, usted ganará comisiones. ¡Esto es una gran ventaja para todos! ¡No olvide compartirlo con todos sus conocidos!`,
      mensaje: `Hola 👋, te quiero hacer un regalo. Con este enlace podrás obtener un test de salud ❤️‍🩹gratuito con el podrás evaluar tu estado de salud actual, espero que todo salga bien, pero si hay algo que corregir te dará unas excelentes recomendaciones de parte del Dr. Ryan Goodkin.
Hazlo ahora mismo, es gratuito 😉.`
    }
  ];

  const [resultados, setResultados] = useState([]);

  useEffect(() => {
    const guardados = enlaces.map(e => {
      const valor = localStorage.getItem(`msg-${e.id}`) || e.mensaje;
      return { ...e, mensaje: valor };
    });
    setResultados(guardados);
  }, []);

  const guardarMensaje = (id, nuevoMensaje) => {
    localStorage.setItem(`msg-${id}`, nuevoMensaje);
    setResultados(prev =>
      prev.map(r => r.id === id ? { ...r, mensaje: nuevoMensaje } : r)
    );
  };

  return (
    <div style={{ padding: '1rem', maxWidth: '700px', margin: '0 auto', textAlign: 'center' }}>
      <img src="logo-comunidad.png" alt="Logo Comunidad" style={{ maxWidth: '200px', marginBottom: '1rem' }} />
      <h2>Generador de Enlaces</h2>
      <input
        placeholder="Tu nombre de usuario"
        value={usuario}
        onChange={(e) => setUsuario(e.target.value)}
        style={{ width: '100%', padding: '0.5rem', marginBottom: '1rem' }}
      />
      <button
        onClick={() => {
          const nuevos = resultados.map(e => ({
            ...e,
            vista: `💬 ${e.mensaje}

👉 ${e.url.replace("{usuario}", usuario)}`
          }));
          setResultados(nuevos);
        }}
        style={{ padding: '0.5rem 1rem' }}
      >
        Generar Enlaces
      </button>

      {resultados.map((r, i) => (
        <div key={i} style={{ border: '1px solid #ccc', padding: '1rem', borderRadius: '8px', marginTop: '1rem', textAlign: 'left' }}>
          <p><strong>{r.descripcion}</strong></p>
          <textarea
            rows="5"
            style={{ width: '100%' }}
            value={r.mensaje}
            onChange={(e) => guardarMensaje(r.id, e.target.value)}
          />
          {r.vista && (
            <>
              <p style={{ marginTop: '0.5rem' }}><strong>Mensaje final:</strong></p>
              <textarea readOnly rows="4" style={{ width: '100%' }} value={r.vista}></textarea>
              <div style={{ marginTop: '0.5rem', display: 'flex', gap: '0.5rem' }}>
                <button onClick={() => navigator.clipboard.writeText(r.vista)}>Copiar</button>
                <button onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(r.vista)}`, '_blank')}>Compartir por WhatsApp</button>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default App;